import { Button, Result, Space } from "antd";
import React, { useState, useEffect } from "react";
import { Outlet } from "react-router";

function ResolutionTracker() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 340); // You can adjust the threshold as needed
    };

    // Initial check
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return <>{isMobile ? <MobileComponent /> : <DesktopComponent />}</>;
}

function MobileComponent() {
  return (
    <Space
      style={{ display: "flex", height: "100vh", justifyContent: "center" }}
    >
      <Result
        status="error"
        title="This website not accessible with lower screen resolution."
        subTitle="For Mobile & Tab Users , Please download our Android application from below."
        extra={
          <Button type="primary" key="console" href={process.env.REACT_APP_MOBILE_APP}>
            APK Link
          </Button>
        }
      />
    </Space>
  );
}

function DesktopComponent() {
  return <Outlet />;
}

export default ResolutionTracker;
